module.exports = __webpack_public_path__ + "img/survey-ship.6624117c.png";